import { Discount } from "../../models/Discount";
import { DiscountType } from "../../views/discounts/types";

export const REQUEST_DISCOUNTS = "REQUEST_DISCOUNTS";
export const REQUEST_DISCOUNTS_DONE = "REQUEST_DISCOUNTS_DONE";

interface Payload {
  discounts: ReadonlyArray<Discount>;
  discountTypes: ReadonlyArray<DiscountType>;
}

export interface FetchDiscounts {
  type: typeof REQUEST_DISCOUNTS;
  payload: Payload;
}

export interface FetchDiscountsDone {
  type: typeof REQUEST_DISCOUNTS_DONE;
  payload: Payload;
}

export type DiscountActionTypes = FetchDiscounts | FetchDiscountsDone;

export interface DiscountState {
  discounts: ReadonlyArray<Discount>;
  discountTypes: ReadonlyArray<DiscountType>;
  isLoading: boolean;
}
